<template>

    <div class="row">
        <div class="col-12 col-lg-6" v-for="photo in photos">
            <div :class="`photo ${photo.ID}`" :style="`background-image: url(${photo.imgUrl});`">
                <span class="icon-deconnexion" @click="askToKillPhoto(photo.ID)"></span>
            </div>
        </div>


    </div>
</template>

<script>
    import Ajax from '../../Ajax';
    import $ from 'jquery'

    export default {
        props: {
            photos: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                activeIndex: 0,
            };
        },
        watch: {},
        computed: {},
        methods: {
            askToKillPhoto(id) {
                this.removeSocialPhoto(id);
            },
            removeSocialPhoto(id) {
                Ajax.post(window.GrandsEspaces.adminUrl, {
                    action: 'ge_remove_social_photo',
                    photo_id: id,
                }, {
                    xhrFields: {
                        withCredentials: true,
                    },
                })
                    .then(() => {

                        $('.dashboard-social-wall .photo.'+id).parent().fadeOut(400);
                    });
            },
        },
        created() {

        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/social-wall/SocialWallDashboardList.vue